import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {  IItemName, IItemNameFilter, IItemsNamesPagination, IItemsNamesState, IItemNameRemoveFailureActionPayload, IItemNameSave, } from './types'


const initialState: IItemsNamesState = {
    data: [], 
    pagination: {
        count: 0,
        countFiltered: 0,
    },
    isLoading: false
}

export const itemsNamesSlice = createSlice({
  name: 'names',
  initialState,
  reducers: {
    itemsNamesListRequest: (state, action?: PayloadAction<IItemNameFilter|undefined>) => {
        state.isLoading = true
    },
    itemsNamesListSuccess: (state, action: PayloadAction<IItemName[]>) => {
        state.data = action.payload
        state.isLoading = false
    },
    itemsNamesListFailure: (state, action: PayloadAction<ISystemErrors>) => {
        state.error = action.payload
        state.isLoading = false
    },
    startEditingItemName: (state, action: PayloadAction<IItemName>) => {
    state.draftItemName = action.payload;
    },
    stopEditingItemName: (state) => {
    state.draftItemName = undefined;
    },
    itemNameDraftUpdate: (state, action: PayloadAction<IItemName>) => {
    state.draftItemName = action.payload;
    
    },
    itemsNamesSaveRequest: (state, action: PayloadAction<IItemName>) => {
    if (state.draftItemName){
        state.draftItemName.isSaving = true; 
        state.draftItemName.error = undefined;
    }
    },
    itemsNamesSetPagination: (state, action: PayloadAction<IItemsNamesPagination>) => {
        state.pagination = action.payload
        
    },
    itemsNamesSaveSuccess: (state, action: PayloadAction<IItemName>) => {
    const oldItemName = state.data.find(itemName => itemName.id === action.payload.id)
    
    if (!oldItemName) {
        state.data.push({
        ...action.payload,
        error: undefined
        })
        state.data = state.data.sort((a, b) => a.name.localeCompare(b.name));
    }
    else {
        state.data = state.data.map(itemName => {
        if (itemName.id !== action.payload.id) return itemName;

        return {
            ...itemName,
            ...action.payload,

            isSaving: false,
            error: undefined
        }
        }).sort((a, b) => a.name.localeCompare(b.name));
    }
    state.draftItemName = undefined;
    },

    itemsNamesSaveFailure: (state, action: PayloadAction<IItemNameSave>) => {
    if(state.draftItemName){
        state.draftItemName.isSaving = false
        state.draftItemName.error = action.payload.error
    }
    },
    itemNameRemoveRequest: (state, action: PayloadAction<string>) => {
    state.data = state.data.map(itemName => {
        if(itemName.id !== action.payload) return itemName;

        return {
        ...itemName,
        isDeleting: true
        }
    })
    },
    itemNameRemoveSuccess: (state, action: PayloadAction<string>) => {
    state.data = state.data.filter(itemName => itemName.id !== action.payload)
    },
    itemNameRemoveFailure: (state, action: PayloadAction<IItemNameRemoveFailureActionPayload>) => {
    state.data = state.data.map(itemName => {
        if(itemName.id !== action.payload.itemNameId) return itemName;

        return {
        ...itemName,
        isDeleting: false,
        error: action.payload.error
        }
    })
    },
}
})

// Action creators are generated for each case reducer function
export const {
    itemsNamesListRequest,
    itemsNamesListSuccess,
    itemsNamesListFailure,
    startEditingItemName,
    itemNameDraftUpdate,
    itemsNamesSaveRequest,
    itemsNamesSetPagination,
    itemsNamesSaveSuccess,
    itemsNamesSaveFailure,
    itemNameRemoveRequest,
    itemNameRemoveSuccess,
    itemNameRemoveFailure,
    stopEditingItemName
    
    
} = itemsNamesSlice.actions

export default itemsNamesSlice.reducer